import type { PriceId } from '@iheartjane/types';

import type { MenuProduct as ZMenuProduct } from '@jane/shared/types';

/**
 * What an add-to-bag from the compare modal needs,
 * captured when user clicked the compare toggle.
 */
export interface CompareProductPayload {
  menuProduct: ZMenuProduct;
  priceId: PriceId;
  /** `SmartSortProduct.toJSON()` - credits the originating placement. */
  smartProductJson: string | null;
}

export function isCompareProductPayload(
  value: unknown
): value is CompareProductPayload {
  if (!value || typeof value !== 'object') return false;
  const payload = value as Record<string, unknown>;
  return (
    typeof payload['priceId'] === 'string' &&
    typeof payload['menuProduct'] === 'object' &&
    payload['menuProduct'] !== null
  );
}
